




























import Vue, { PropType } from 'vue';
import { State } from '@/stores/validation';

interface TabLink {
  text: string;
  to: string | Location;
  nested?: boolean;
  validationId?: string;
  page?: string;
}

const gapSizeType = ['small', 'large'];

export default Vue.extend({
  name: 'GTabLinks',
  props: {
    currentPage: { type: String as PropType<string | null>, default: null },
    tabLinks: { type: Array as PropType<TabLink[]>, default: () => [] },
    gapSize: {
      type: String as PropType<string>,
      validator: (prop: string) => gapSizeType.includes(prop),
      default: 'small',
    },
  },
  computed: {
    $validation(): State {
      return this.$stores.validation.state;
    },
  },
  methods: {
    isInvalid(validationId: string) {
      if (!this.$validation || !this.$validation[validationId]) {
        return false;
      }
      return this.$validation[validationId].invalid;
    },
  },
});
